import React, { useState, useEffect } from "react";
import {
  CreateMetaData,
  CreateNewParamenter,
  DeleteNewMeta,
  MetaDataList,
  getParameterDetails,
  FetchDataTypes,
  MetaDataDetails
} from "../../api/api";
import Cookies from "js-cookie";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import clsx from "clsx";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { string } from "yup";
import {ProcessList} from "./ProcessList"

const CreateMetaDataForm = (handleNext, handleCancel, onNext) => {
  const [data, setData] = useState({
    name: "",
    label: "",
    description: "",
    schemaName: "",
    executionMethod: "",
    spName: "",
    resourceUrl: "",
    httpMethod: "",
    returnType: "",
    submitButtonText: "",
    cancelButtonText: "",
    allowExecute: false,
    allowExcelExport: false,
    allowPdfExport: false,
    allowCsvExport: false,
    active: false,
  });

  const [errors, setErrors] = useState({
    name: "",
    executionMethod: "",
    spName: "",
    resourceUrl: "",
    httpMethod: "",
    returnType: "",
  });
  const emptyParamData = {
    //id: "",
    name: "",
    parameterType: "",
    dbType: "",
    type: null,
    Position: 0,
    isNullable: false,
    defaultValue: "",
    length: 0,
    precision: 0,
    scale: 0,
    inputType: "",
    label: "",
    placeHolder: "",
    tooltip: "",
    InputDataSource: [],
    options: [],
    active: false,
    pattern: "",
  };

  const [showForm, setShowForm] = useState(false);
  const [first, setfirst] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [openInputData, setOpenInputData] = useState(true);
  const [isTabOpen, setIsTabOpen] = useState(false);
  const [metaData, setMetadata] = useState("");
  const [newParamdata, setNewParamdata] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isResponse, setIsResponse] = useState(true);
  const [validatemeta, setValidatemeta] = useState(false);
  const [metaList, setMetaList] = useState('');
  const [paramDetails, setParamDetails] = useState('');
  const [selectType, setSelectType] = useState("");
  const [inputdataSource, setInputdataSource] = useState('')
  const [requestTypeList, setRequestTypeList] = useState('')
  const [requestTypeSelected, setRequestTypeSelected] = useState('')
  const [requestTypeListSelectedItems, setRequestTypeListSelectedItems] = useState('')
  const [getRequestTypeKey, setGetRequestTypeKey] = useState('')
  const [requestTypeValue, setRequestTypeValue] = useState('')
  const [requestTypeLabel, setRequestTypeLabel] = useState('')
  const selectedClient = Cookies.get("client")
  
  const updateData = (event) => {
    let value;
    if (event.target.name === "allowExecute") {
      value = event.target.value === "true";
    } else if (event.target.name === "allowExcelExport") {
      value = event.target.value === "true";
    } else if (event.target.name === "allowPdfExport") {
      value = event.target.value === "true";
    } else if (event.target.name === "allowCsvExport") {
      value = event.target.value === "true";
    } else if (event.target.name === "active") {
      value = event.target.value === "true";
    } else {
      value = event.target.value;
    }
    setData({
      ...data,
      [event.target.name]: value,
    });
  };

  const handleSubmitMetaData = (e) => {
    e.preventDefault();
    setValidatemeta(true);

    setIsTabOpen(true);
    let isError = false;

    // if (data.name === "") {
    //   isError = true;
    //   errors.name = "Name is required.";
    // }
    // if (data.executionMethod === "") {
    //   isError = true;
    //   errors.executionMethod = "Execution Method is required.";
    // }
    // if (data.spName === "") {
    //   isError = true;
    //   errors.spName = "spName is required.";
    // }
    // if (data.resourceUrl === "") {
    //   isError = true;
    //   errors.resourceUrl = "resourceUrl is required.";
    // }
    // if (data.httpMethod === "") {
    //   isError = true;
    //   errors.httpMethod = "httpMethod is required.";
    // }
    // if (data.returnType === "") {
    //   isError = true;
    //   errors.returnType = "returnType is required.";
    // }

    setShowForm(true);
    setTabIndex(1);
    setIsTabOpen(true);
  };

  


  const [forms, setForms] = useState([emptyParamData]);

  const handleAdd = () => {
    setForms([...forms, emptyParamData]);
  };
  const removeFormFields = (index) => {
    let data = [...forms];
    data.splice(index, 1);
    setForms(data);
  };

  // options add and remove code
  const [optionsList, setOptionsList] = useState([{ label: "", value: "" }]);
  const addOptionsFields = () => {
    let object = {
      label: "",
      value: "",
    };
    setOptionsList([...optionsList, object]);
  };
  const removeFields = (index) => {
    let data = [...optionsList];
    data.splice(index, 1);
    setOptionsList(data);
  };

  const handleSubmitParaData = (e, index) => {
    e.preventDefault();

    let isErrorParam = false;

    if (data.type === "") {
      isErrorParam = true;
      errors.type = "type is required.";
    }
    if (data.Position === "") {
      isErrorParam = true;
      errors.Position = "Position is required.";
    }
    if (data.length === "") {
      isErrorParam = true;
      errors.length = "length is required.";
    }
    if (data.precision === "") {
      isErrorParam = true;
      errors.precision = "precision is required.";
    }
    if (data.scale === "") {
      isErrorParam = true;
      errors.scale = "scale is required.";
    }
    if (data.inputType === "") {
      isErrorParam = true;
      errors.inputType = "inputType is required.";
    }

    setIsSubmit(true);
    try {
      CreateMetaData(data, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setMetadata(response);
          console.log(response);
          if (response.errors) {
            toast.error("Error Creating Process !", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Error Creating Process !", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    } catch (error) {
      console.error(error);
      toast.error("Error Creating Process !", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  
  useEffect(() => {
    console.log("aa",forms)
    if (metaData.id !== undefined && metaData.id) {
      CreateNewParamenter(metaData.id, forms, Cookies.get("newJwt"))
        .then((response) => response?.json())
        .then((response) => {
          setNewParamdata(response);
          response.errors
            ? toast.error("Error Creating Process !", {
                position: toast.POSITION.TOP_RIGHT,
              })
            : toast.success("Process Created Successfully!", {
                position: toast.POSITION.TOP_RIGHT,
              });

          if (response.errors) {
            DeleteNewMeta(metaData.id, Cookies.get("newJwt"))
              .then((response) => response?.json())
              .then((response) => {
                //setNewParamdata(response);
                console.log("delete Meta", response);
                toast.error("Error Creating Process !", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              });
          }
        })
        .catch((error) => {
          DeleteNewMeta(metaData.id, Cookies.get("newJwt"))
            .then((response) => response?.json())
            .then((response) => {
              //setNewParamdata(response);
              console.log("delete Meta", response);
              setIsResponse(false);
              toast.error("Error Creating Process !", {
                position: toast.POSITION.TOP_RIGHT,
              });
            });
          console.log("error", error);
        });
    }
  }, [metaData]);
  const handleParamChange = (e, index) => {
    const updatedOptions = [...forms.options];
    updatedOptions[index] = {
      ...updatedOptions[index],
      [e.target.name]: e.target.value,
    };
    setForms({
      ...forms,
      options: updatedOptions,
    });
  };

  useEffect(() => {
    MetaDataList(Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setMetaList(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [MetaDataList]);

  
  console.log(inputdataSource)

  useEffect(() => {
    getParameterDetails(inputdataSource, Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setParamDetails(response.filter((item) => item.inputDataSource.length > 0));
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [inputdataSource])
  
  console.log(paramDetails)


 
  useEffect(() => {
    FetchDataTypes("InputDataSourceOptions", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setRequestTypeList(response.filter((item) => item.spName === "GetAPIData"))
        console.log(response.filter((item) => item.spName === "GetAPIData"));
      })
      .catch((error) => {
        console.error(error);
      });
  }, [])

  function selectedRequestType(){
    forms.map((form) =>{
      return setRequestTypeSelected(form?.InputDataSource[0]?.ParameterData[0]?.Val)
  })
  }
  console.log(forms?.[0]?.InputDataSource?.[0]?.parameterData?.[0]?.Val)
  useEffect(() => {
    const requestType = forms?.[0]?.InputDataSource?.[0]?.parameterData?.[0]?.Val
    //const requestType = "Client"
    if(requestType){
      FetchDataTypes("InputDataSourceOptionsDetails",parseInt(selectedClient),  Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
       setRequestTypeListSelectedItems(response.filter((item) => item.requestType === requestType))
        console.log(response.filter((item) => item.requestType === requestType));
      })
      .catch((error) => {
        console.error(error);
      });
    }
    
  }, [forms?.[0]?.InputDataSource?.[0]?.parameterData?.[0]?.Val])

  useEffect(() => {
    const selectedMetaID = forms?.[0]?.InputDataSource?.[0]?.metaDataID
    if(selectedMetaID){
      MetaDataDetails(selectedMetaID, Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
       setGetRequestTypeKey(response)
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
    }
    
  }, [forms?.[0]?.InputDataSource?.[0]?.metaDataID])
  console.log(requestTypeListSelectedItems)

  
  
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Create Process</h1>
      </div>
      <div className="row w-100 card p-4">
        <div className="w-100 tradeForm position-relative">
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            <TabList>
              <Tab>Meta Data</Tab>
              <Tab>Parameter Data</Tab>
              <Tab>Parameter List</Tab>
            </TabList>

            <TabPanel>
              <form onSubmit={handleSubmitMetaData} className="row g-6 mt-2">
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">Name:</label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className={clsx(
                        "form-control ",
                        errors.name ? "is-invalid" : null
                      )}
                      name="name"
                      placeholder="Name"
                      onChange={updateData}
                      required
                    />
                    {errors.name && (
                      <span classname="formError my-2 w-100 ">
                        {errors.name}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">Label:</label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="label"
                      placeholder="Label"
                      onChange={updateData}
                    />
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Description:
                  </label>
                  <div className="col-sm-8">
                    <textarea
                      className="form-control "
                      name="description"
                      placeholder="description"
                      onChange={updateData}
                    />
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Schema Name:
                  </label>
                  <div className="col-sm-8">
                    {/* <input
                      type="text"
                      className="form-control "
                      name="schemaName"
                      placeholder="SchemaName"
                      defaultValue='dbo'
                      onChange={updateData}
                    /> */}
                    <select
                      className="form-control "
                      name="schemaName"
                      onChange={updateData}
                    >
                      <option value="">Select</option>
                      <option value="dbo">dbo</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Execution Method:
                  </label>
                  <div className="col-sm-8">
                    {/* <input
                      type="text"
                      className={clsx(
                        "form-control ",
                        errors.executionMethod ? "is-invalid" : null
                      )}
                      name="executionMethod"
                      placeholder="ExecutionMethod"
                      onChange={updateData}
                      //required
                    /> */}
                    <select
                      className={clsx(
                        "form-control ",
                        errors.executionMethod ? "is-invalid" : null
                      )}
                      name="executionMethod"
                      onChange={updateData}
                      required
                    >
                      <option value="">Select</option>
                      <option value="sp">SP</option>
                      <option value="api">API</option>
                    </select>
                    {errors.executionMethod && (
                      <span classname="formError my-2 w-100">
                        {errors.executionMethod}
                      </span>
                    )}
                    {/* <small className="">Accepted values sp or api</small> */}
                  </div>
                </div>
                {data.executionMethod === "sp" ? 
                <>
                <div className="col-md-5 mt-4 d-flex">
                      <label className="col-sm-4 col-form-label">spName:</label>
                      <div className="col-sm-8">
                        <input
                      type="text"
                      className={clsx(
                        "form-control ",
                        errors.spName ? "is-invalid" : null
                      )}
                      name="spName"
                      placeholder="spName"
                      onChange={updateData}
                    />
                        {errors.spName && (
                          <span classname="formError my-2 w-100">
                            {errors.spName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-5 mt-4 d-flex">
                      <label className="col-sm-4 col-form-label">
                        returnType:
                      </label>
                      <div className="col-sm-8">
                        <select
                          className={clsx(
                            "form-control ",
                            errors.returnType ? "is-invalid" : null
                          )}
                          name="returnType"
                          onChange={updateData}
                          required
                        >
                          <option value="">Select</option>
                          <option value="dataprocess">Data Process</option>
                          <option value="dataset">Data Set</option>
                        </select>
                        {errors.returnType && (
                          <span classname="formError my-2 w-100">
                            {errors.returnType}
                          </span>
                        )}
                      </div>
                    </div>
                </> : null }
                {data.executionMethod === "api" ? (
                  <>
                    
                    <div className="col-md-5 mt-4 d-flex">
                      <label className="col-sm-4 col-form-label">
                        resourceUrl:
                      </label>
                      <div className="col-sm-8">
                        {/* <input
                    type="text"
                    className={clsx(
                      "form-control ",
                      errors.resourceUrl ? "is-invalid" : null
                    )}
                    name="resourceUrl"
                    placeholder="resourceUrl"
                    onChange={updateData}
                    //required
                  /> */}
                        <select
                          className={clsx(
                            "form-control ",
                            errors.resourceUrl ? "is-invalid" : null
                          )}
                          name="resourceUrl"
                          onChange={updateData}
                          required
                        >
                          <option value="">Select</option>
                          <option value="api">API</option>
                        </select>
                        {/* <small className="">Accepted values API</small> */}
                        {errors.resourceUrl && (
                          <span classname="formError my-2 w-100">
                            {errors.resourceUrl}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-5 mt-4 d-flex">
                      <label className="col-sm-4 col-form-label">
                        httpMethod :
                      </label>
                      <div className="col-sm-8">
                        {/* <input
                    type="text"
                    className={clsx(
                      "form-control ",
                      errors.httpMethod ? "is-invalid" : null
                    )}
                    name="httpMethod"
                    placeholder="httpMethod"
                    onChange={updateData}
                    //required
                  /> */}
                        <select
                          className={clsx(
                            "form-control ",
                            errors.httpMethod ? "is-invalid" : null
                          )}
                          name="httpMethod"
                          onChange={updateData}
                          required
                        >
                          <option value="">Select</option>
                          <option value="api">API</option>
                        </select>
                        {errors.httpMethod && (
                          <span classname="formError my-2 w-100">
                            {errors.httpMethod}
                          </span>
                        )}
                        {/* <small className="">Accepted Method is api</small> */}
                      </div>
                    </div>
                    
                  </>
                ) : null}

                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Submit Button Text:
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      name="submitButtonText"
                      placeholder="submitButtonText"
                      onChange={updateData}
                    />
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Cancel Button Text:
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control "
                      name="cancelButtonText"
                      placeholder="cancelButtonText"
                      onChange={updateData}
                    />
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Allow Execute:
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-control "
                      name="allowExecute"
                      onChange={updateData}
                    >
                      <option value="">Select</option>
                      <option value={false}>NO</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div>
                </div>
                {data.allowExecute === true ? 
                <>
<div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Allow Excel Export:
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-control "
                      name="allowExcelExport"
                      onChange={updateData}
                    >
                      <option value="">Select</option>
                      <option value={false}>NO</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Allow Pdf Export:
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-control "
                      name="allowPdfExport"
                      onChange={updateData}
                    >
                      <option value="">Select</option>
                      <option value={false}>NO</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">
                    Allow Csv Export:
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-control "
                      name="allowCsvExport"
                      onChange={updateData}
                    >
                      <option value="">Select</option>
                      <option value={false}>NO</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div>
                </div>
                </> 
                : null}
                
                <div className="col-md-5 mt-4 d-flex">
                  <label className="col-sm-4 col-form-label">Active:</label>
                  <div className="col-sm-8">
                    <select
                      className="form-control "
                      name="active"
                      onChange={updateData}
                    >
                      <option value="">Select</option>
                      <option value={false}>NO</option>
                      <option value={true}>Yes</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-12 mb-4">
                  <button
                    type="submit"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end "
                    onClick={onNext}
                  >
                    Next
                  </button>
                  <button
                    type="button"
                    className="btn d-inline-flex align-items-center btn-xs btn btn-link float-end"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </TabPanel>
            <TabPanel>
              <form onSubmit={handleSubmitParaData}>
                {forms.map((form, index) => (
                  <div
                    key={index}
                    className="d-inline-flex flex-wrap w-100 mb-4 parameterForm"
                  >
                    <h7 className="w-100">
                      Parameter Data {index + 1}
                      {index !== 0 ? (
                        <button
                          className="btn float-end"
                          type="button"
                          onClick={removeFormFields}
                        >
                          <i className="align-middle fas fa-trash"></i>
                        </button>
                      ) : null}
                    </h7>

                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">Name:</label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className={clsx(
                            "form-control ",
                            errors.paramname ? "is-invalid" : null
                          )}
                          value={form.name}
                          required
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].name = e.target.value;
                            setForms(newForms);
                          }}
                        />
                        <div class="invalid-feedback">
                          Please provide a valid name.
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">
                        Parameter Type:
                      </label>
                      <div className="col-sm-8">
                        <select
                          type="text"
                          required
                          className={clsx(
                            "form-control ",
                            errors.parameterType ? "is-invalid" : null
                          )}
                          value={form.parameterType}
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].parameterType = e.target.value;
                            setForms(newForms);
                          }}
                        >
                          <option value="">Select</option>
                          <option value="IN">IN</option>
                          <option value="OUT">OUT</option>
                        </select>
                        <div class="invalid-feedback">
                          Please provide a valid Parameter Type.
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">
                        DB Type:
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-control "
                          name="dbType"
                          required
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].dbType = e.target.value;
                            setForms(newForms);
                          }}
                        >
                          <option value="">Select</option>
                          <option value="varchar">varchar</option>
                          <option value="int">int</option>
                          <option value="decimal">decimal</option>
                          <option value="smalldatetime">smalldatetime</option>
                          <option value="datetime">datetime</option>
                          <option value="char">char</option>
                        </select>
                        <div class="invalid-feedback">
                          Please provide a valid dbType.
                        </div>
                      </div>
                    </div>
                    {data.executionMethod === "api" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">Type:</label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            name="type"
                            value={form.type}
                            required
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].type = e.target.value;
                              setForms(newForms);
                            }}
                          />
                          <small className="">Default value dbo</small>
                        </div>
                      </div>
                    ) : null}

                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">
                        Position:
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="number"
                          className="form-control "
                          name="Position"
                          placeholder="Position"
                          required
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].Position = parseInt(e.target.value);
                            setForms(newForms);
                          }}
                        />
                        {/* <small className="">Accepted values sp or api</small> */}
                      </div>
                    </div>
                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">
                        isNullable:
                      </label>
                      <div className="col-sm-8">
                        <select
                          className="form-control "
                          name="isNullable"
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].isNullable =
                              e.target.value === "true";
                            setForms(newForms);
                          }}
                        >
                          <option value="">Select</option>
                          <option value={false}>NO</option>
                          <option value={true}>Yes</option>
                        </select>
                        {/* <small className="">Execution Method is sp</small> */}
                      </div>
                    </div>
                    {data.executionMethod === "sp" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Default Value:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control "
                            value={form.defaultValue}
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].defaultValue = e.target.value;
                              setForms(newForms);
                            }}
                          />
                          {/* <small className="">Execution Method is api</small> */}
                        </div>
                      </div>
                    ) : null}

                    {data.executionMethod === "sp" &&
                    form.dbType === "decimal" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Precision:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="number"
                            className="form-control "
                            value={form.precision}
                            required
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].precision = parseInt(
                                e.target.value
                              );
                              setForms(newForms);
                            }}
                          />
                        </div>
                      </div>
                    ) : null}

                    {data.executionMethod === "sp" &&
                    form.dbType === "decimal" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Scale:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="number"
                            className="form-control "
                            value={form.scale}
                            required
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].scale = parseInt(e.target.value);
                              setForms(newForms);
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                    {form.parameterType === "IN" ? (
                      <>
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Label:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control "
                              name="label"
                              placeholder="label"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].label = e.target.value;
                                setForms(newForms);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            PlaceHolder:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control "
                              name="placeHolder"
                              placeholder="placeHolder"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].placeHolder = e.target.value;
                                setForms(newForms);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Tooltip:
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control "
                              name="tooltip"
                              placeholder="tooltip"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].tooltip = e.target.value;
                                setForms(newForms);
                              }}
                            />
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">Active:</label>
                      <div className="col-sm-8">
                        <select
                          className="form-control "
                          name="active"
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].active = e.target.value === "true";
                            setForms(newForms);
                          }}
                        >
                          <option value="">Select</option>
                          <option value={false}>NO</option>
                          <option value={true}>Yes</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-5 mt-2">
                      <label className="col-sm-4 col-form-label">
                        Pattern:
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control "
                          value={form.pattern}
                          onChange={(e) => {
                            const newForms = [...forms];
                            newForms[index].pattern = e.target.value;
                            setForms(newForms);
                          }}
                        />
                      </div>
                    </div>
                    {data.executionMethod === "sp" &&
                    form.dbType === "varchar" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          length:
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control "
                            value={form.length}
                            required
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].length = parseInt(e.target.value);
                              setForms(newForms);
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                    {form.parameterType === "IN" ? (
                      <>
                        <div className="col-md-5 mt-2">
                          <label className="col-sm-4 col-form-label">
                            Input Type:
                          </label>
                          <div className="col-sm-8">
                            <select
                              className="form-control "
                              name="inputType"
                              required
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].inputType = e.target.value;
                                setForms(newForms);
                              }}
                            >
                              <option value="">Select</option>
                              <option value="select">Select Options</option>
                              <option value="date">Date</option>
                              <option value="radio">Radio</option>
                              <option value="switch">Switch</option>
                              <option value="number">Number</option>
                              <option value="text">Text</option>
                              <option value="file">File</option>
                              <option value="textarea">Textarea</option>
                              <option value="checkboxgroup">Checkbox</option>
                              <option value="maskedtext">Maskedtext</option>
                            </select>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {form.inputType === "radio" ||
                    form.inputType === "select" ||
                    form.inputType === "checkboxgroup" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Select Type:
                        </label>
                        <div className="col-sm-8 d-flex">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="options"
                              id="flexRadioDefault1"
                              checked={selectType === "options"}
                              onChange={(e) => setSelectType("options")}
                            />
                            <label
                              class="form-check-label"
                              for="flexRadioDefault1"
                            >
                              Options
                            </label>
                          </div>
                          <div class="form-check mx-4">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="inputSelect"
                              id="flexRadioDefault2"
                              checked={selectType === "inputSelect"}
                              onChange={(e) => setSelectType("inputSelect")}
                            />
                            <label
                              class="form-check-label"
                              for="flexRadioDefault2"
                            >
                              InputData Source
                            </label>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    
                    {selectType === "inputSelect" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Metadata:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="metaDataID"
                            onChange={(e) => {
                              const newForms = [...forms];
                              //newForms[index].InputDataSource[0].metaDataID = e.target.value;
                              newForms[index].InputDataSource[0] = newForms[
                                index
                              ].InputDataSource[0]
                                ? {
                                    ...newForms[index].InputDataSource[0],
                                    metaDataID: e.target.value,
                                  }
                                : {
                                    metaDataID: e.target.value,
                                  };
                              setForms(newForms);
                              console.log(newForms);
                            }}
                            
                          >
                            <option value="select">Select</option>
                            {metaList &&
                              metaList.map((e, key) => {
                                return (
                                  <option key={key.id} value={e.id}>
                                    {e.name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    ) : null}
                   {
                    selectType === "inputSelect" ?
                    <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                        Parameter Value:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="Val"
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].InputDataSource[0].parameterData = [{
                                  Key: "",
                                  Val: e.target.value
                                }]
                              
                              setForms(newForms);
                            }}
                          >
                            <option value="select">Select</option>
                            
                              {requestTypeList &&
                                requestTypeList.map((e, key) => {
                                  return (
                                    <option key={key.id} value={e.id}>
                                      {e.requestType}
                                    </option>
                                  );
                                })}
                            
                          </select>
                        </div>
                      </div>
                      : null
                   }
                   {
                    selectType === "inputSelect" ?
                    <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Parameter Key:
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control "
                            name="Key"
                            onChange={(e) => {
                              const newForms = [...forms];
                              newForms[index].InputDataSource[0].parameterData = [{
                                  Key: e.target.value,
                                  Val: ""
                                }]
                              
                              setForms(newForms);
                            }}
                          >
                            <option value="select">Select</option>
                            
                              {getRequestTypeKey &&
                                getRequestTypeKey.map((e, key) => {
                                  return (
                                    <option key={key.id} value={e.name}>
                                      {e.name}
                                    </option>
                                  );
                                })}
                            
                          </select>
                        </div>
                      </div>
                      : null
                   }
                      
                      
                    

                    {selectType === "inputSelect" ? (
                      <div className="col-md-5 mt-2 d-flex">
                        <div className="col-sm-5">
                          <label className="col-sm-4 col-form-label">
                            Label:
                          </label>
                          <div className="col-sm-8">
                            <select
                              className="form-control "
                              name="Label"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].InputDataSource[0].Label = e.target.value;
                                setForms(newForms);
                              }}
                            >
                              <option value="select">Select</option>
                              {requestTypeListSelectedItems &&
                                requestTypeListSelectedItems.map((e, key) => {
                                    return (
                                      <option
                                        key={key.id}
                                        value={e.options}
                                      >
                                        {e.options}
                                      </option>
                                    );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <label className="col-sm-4 col-form-label">
                            Value:
                          </label>
                          <div className="col-sm-8">
                            <select
                              className="form-control "
                              name="Value"
                              onChange={(e) => {
                                const newForms = [...forms];
                                newForms[index].InputDataSource[0].Value = e.target.value;
                                setForms(newForms);
                              }}
                            >
                              <option value="select">Select</option>
                              {requestTypeListSelectedItems &&
                                requestTypeListSelectedItems.map((e, key) => {
                                    return (
                                      <option
                                        key={e.id}
                                        value={e.options}
                                      >
                                        {e.options}
                                      </option>
                                    );
                                })}
                            </select>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {selectType === "options" ? (
                      <div className="col-md-5 mt-2">
                        <label className="col-sm-4 col-form-label">
                          Options:
                        </label>
                        <div className="col-sm-8">
                          {openInputData ? (
                            <div className="">
                              {optionsList.map((form, i) => {
                                return (
                                  <div key={i} className="d-flex my-2">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="label"
                                      placeholder="label"
                                      value={form?.options}
                                      required
                                      onChange={(e) => {
                                        var newForms = [...forms];

                                        newForms[index].options[i] = newForms[
                                          index
                                        ].options[i]
                                          ? {
                                              ...newForms[index].options[i],
                                              label: e.target.value,
                                            }
                                          : {
                                              label: e.target.value,
                                              value: "",
                                            };
                                        setForms(newForms);
                                      }}
                                    />
                                    <input
                                      name="value"
                                      type="text"
                                      placeholder="value"
                                      className="form-control mx-2"
                                      value={form.options}
                                      required
                                      onChange={(e) => {
                                        var newForms = [...forms];
                                        newForms[index].options[i] = newForms[
                                          index
                                        ].options[i]
                                          ? {
                                              ...newForms[index].options[i],
                                              value: e.target.value,
                                            }
                                          : {
                                              label: "",
                                              value: e.target.value,
                                            };
                                        setForms(newForms);
                                      }}
                                    />
                                    <button
                                      className="btn"
                                      type="button"
                                      onClick={addOptionsFields}
                                    >
                                      <i className="align-middle fas fa-plus"></i>
                                    </button>

                                    <button
                                      className="btn"
                                      onClick={() => removeFields(index)}
                                    >
                                      <i className="align-middle fas fa-minus"></i>
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                ))}

                <button
                  type="submit"
                  className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end "
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end mx-2"
                  onClick={handleAdd}
                >
                  Add
                </button>
                <button
                  type="submit"
                  className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-end mx-2"
                  onClick={() => setTabIndex(0)}
                >
                  Back
                </button>
              </form>
            </TabPanel>
            <TabPanel>
            <ProcessList />
            
            </TabPanel>
          </Tabs>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export { CreateMetaDataForm };
